import { useMutation, useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
/**
 * 热图特殊对应模块接口
 */
export type EffectiveRangeType = 'site' | 'regexp';
export interface UpdateHeatMapSpecialCorrespondenceInput {
    id?: string;
    sid: string;
    regexp: string;
    jsContent: string;
    cssContent: string;
    effectiveRange: EffectiveRangeType;
    description?: string;
}

export interface QueryHeatMapSpecialCorrespondenceInput {
    sid: string;
    url: string;
}

const UPDATE_HEATMAP_CODE_MUATION = gql`
    mutation updateHeatMapSpecialCorrespondence($input: UpdateHeatMapSpecialCorrespondenceInput!) {
        updateHeatMapSpecialCorrespondence(input: $input)
    }
`;

const QUERY_HEATMAP_CODE = gql`
    query getHeatMapSpecialCorrespondence($input: QueryHeatMapSpecialCorrespondenceInput!) {
        getHeatMapSpecialCorrespondence(input: $input) {
            id
            sid
            effectiveRange
            regexp
            cssContent
            jsContent
        }
    }
`;

export async function saveHeatmapCode(params: UpdateHeatMapSpecialCorrespondenceInput) {
    const { mutate } = useMutation(UPDATE_HEATMAP_CODE_MUATION, {
        fetchPolicy: 'no-cache'
    });
    const res = await mutate({
        input: params
    });
    return res?.data?.updateHeatMapSpecialCorrespondence;
}

export async function getHeatmapCode(
    params?: QueryHeatMapSpecialCorrespondenceInput,
    resultCallback?: (T: any) => void,
    rejectCallback?: (err: any) => void
) {
    const { onError, onResult } = useQuery<{
        getHeatMapSpecialCorrespondence: QueryHeatMapSpecialCorrespondenceInput;
    }>(
        QUERY_HEATMAP_CODE,
        { input: params },
        {
            fetchPolicy: 'no-cache'
        }
    );
    onResult(data => {
        if (data?.data?.getHeatMapSpecialCorrespondence) {
            resultCallback &&
                typeof resultCallback === 'function' &&
                resultCallback(data?.data?.getHeatMapSpecialCorrespondence);
        }
    });

    onError(err => {
        rejectCallback && typeof rejectCallback === 'function' && rejectCallback(err);
    });
}
